import React, { useEffect } from 'react';
import { BaseDialog } from 'src/components/common';
import { useFetch } from 'src/utils/hooks/useFetch';
import { GuestApi } from 'src/api/base/Guest';
import { FullSizeProgress } from 'src/routing/RouteSuspense';
import { ContactOverview } from '../ContactOverview';
import { OverviewGuestModalInvite } from './OverviewGuestModalInvite';
import { InterviewApi } from 'src/api/base/Interviews';
import { useResponseFormHandler } from 'src/utils/hooks/useResponseFormHandler';
import { RootState } from 'src/store';
import { useSelector } from 'react-redux';
import { USER_ROLES } from 'src/utils/types/user';
import { IBaseForm } from 'src/utils/types/forms';

type POverviewGuestModal = IBaseForm<any> & {
  open: boolean;
  onClose: () => void;
  guestId: number;
  onSuccess?: () => void;
};

export const OverviewGuestModal: React.FC<POverviewGuestModal> = (props) => {
  const { open, onClose, guestId, onSuccess } = props;
  const user = useSelector((state: RootState) => state.auth.user);

  const [{ response, isLoading }, doFetch] = useFetch<any, any>(
    GuestApi.getGuest,
  );
  
  const [{ response:test, isLoading:testloading, error:testerror }, doFetch1] = useFetch<any, any>(
      InterviewApi.makeInterviewRequest,
    );

    useResponseFormHandler({ test, testerror });

    useEffect(() => {
      if (test && onSuccess) {
        onSuccess();
      }
    }, [test]);

  useEffect(() => {
	  if(guestId) {
		doFetch(guestId);
	  }
  }, [guestId, doFetch]);

  return (
    <BaseDialog
      open={open}
      onClose={onClose}
      title="Guest Details"
      paperStyles={{ maxWidth: '900px', width: '100%' }}
    >
      {isLoading ? (
			<FullSizeProgress />
		) : (
			<ContactOverview guest={response?.data?.data} />
        
		)
      }
      { (user?.role === USER_ROLES.JOURNALIST) ? (
          <OverviewGuestModalInvite
            onSubmit={(data) => {
              doFetch1({ guest_id: guestId, ...data });
            }}
            loading={testloading}
			open={open}
			onClose={onClose}
            errors={testerror}
          />
        ) : (
          <></>
        )
      }
    </BaseDialog>
  );
};
